import React, {Component} from 'react';
import {DocumentTitle, Spinner, ValidatingInput, Page, Form, Icon} from '../widgets/';
import parseQueryString from '../parseQueryString';
import FancyButton from '../widgets/FancyButton';
import {postJson} from '../fetchJson';
import fetchJson from '../fetchJson';
import {uiActions} from '../chrome';
import {connect} from 'react-redux';
import FancyCheckbox from '../widgets/FancyCheckbox';

class ResetPassword extends Component {
	constructor() {
		super();

		const query = parseQueryString(window.location.search);

		this.state = {
			token: query && query.token,
			username: query && query.username,
			tokenValidity: !query || !query.username || !query.token ? false : null,
			resetComplete: false
		};

		// Check validity of token before asking user to confirm password.
		if (this.state.tokenValidity === null) {
			fetchJson(
				`/api/user/${encodeURIComponent(query.username)}/reset/validate?token=${encodeURIComponent(
					query.token
				)}`
			)
				.then(result => {
					this.setState({tokenValidity: true});
				})
				.catch(e => {
					this.setState({tokenValidity: false});
				});
		}

		this.onResetComplete = () => {
			this.setState({resetComplete: true});
		};

		this.onError = () => {
			this.setState({tokenValidity: false});
		};
	}

	render() {
		return (
			<DocumentTitle title="B2Me">
				<Page className="password-reset">
					<section>
						{this.state.resetComplete && (
							<Success
								currentSession={this.props.currentSession}
								showLogin={this.props.showLogin}
							/>
						)}
						{!this.state.resetComplete && this.state.tokenValidity === false ? (
							<InvalidToken tryAgain={this.props.tryAgain} />
						) : null}
						{!this.state.resetComplete && this.state.tokenValidity === true ? (
							<ResetForm
								username={this.state.username}
								token={this.state.token}
								onResetComplete={this.onResetComplete}
								onError={this.onError}
							/>
						) : null}
						{!this.state.resetComplete && this.state.tokenValidity === null ? (
							<ValidatingToken />
						) : null}
					</section>
				</Page>
			</DocumentTitle>
		);
	}
}

class Success extends Component {
	render() {
		return (
			<div>
				<h1>
					<Icon name="thumb_up" size={200} /> Reset successful
				</h1>
				<p>
					Password successfully reset.
					{this.props.currentSession && this.props.currentSession.user ? (
						undefined
					) : (
						<span>
							You can now <FancyButton onClick={this.props.showLogin}>Login</FancyButton> to{' '}
							<em>B2Me</em>
						</span>
					)}
				</p>
			</div>
		);
	}
}

class ValidatingToken extends Component {
	render() {
		return (
			<div>
				<p>Validating token...</p>
				<Spinner />
			</div>
		);
	}
}

class InvalidToken extends Component {
	render() {
		return (
			<div>
				<h1>
					<Icon name="error" size={200} />
					Invalid token
				</h1>
				<p>
					This reset token is invalid or has expired. You can use the button below to try again if
					you like:
				</p>
				<p>
					<FancyButton onClick={this.props.tryAgain}>Try again</FancyButton>
				</p>
				<p>
					If this is unexpected and continues to occur, please contact{' '}
					<a href="https://b2me.zendesk.com">B2Me support.</a>
				</p>
			</div>
		);
	}
}

const getPasswordState = state => {
	if (state.password && state.password.length > 0) {
		if (state.passwordValidity === true) {
			// PW is definitely valid
			return 'valid';
		} else if (state.passwordValidity === false) {
			// PW is definitely invalid
			return 'invalid';
		} else {
			return 'in_use'; // User is still typing
		}
	} else {
		// Nothing entered
		return 'required';
	}
};

const getConfirmPasswordState = state => {
	if (state.confirmPassword && state.confirmPassword.length > 0) {
		if (state.confirmPassword === state.password) {
			return 'valid';
		} else {
			return 'invalid';
		}
	} else {
		// Nothing entered
		return 'required';
	}
};

class ResetForm extends Component {
	constructor() {
		super();

		this.state = {
			password: '',
			passwordValidity: null,
			confirmPassword: '',
			waiting: false
		};

		this.handleKeyPress = e => {
			if (
				e.key === 'Enter' &&
				this.state.password &&
				this.state.password.length >= 8 &&
				this.state.confirmPassword === this.state.password
			) {
				e.preventDefault();
				this.reset();
			}
		};
		this.setPassword = e => this.setState({password: e.target.value, passwordValidity: null});
		this.setConfirmPassword = e => this.setState({confirmPassword: e.target.value});
		this.validatePassword = () => {
			this.setState({
				passwordValidity: !!(this.state.password && this.state.password.length >= 8)
			});
		};

		this.reset = () => {
			this.setState({waiting: true});
			postJson(`/api/user/${encodeURIComponent(this.props.username)}/reset`, {
				password: this.state.password,
				token: this.props.token
			})
				.then(() => {
					this.setState({waiting: false});
					this.props.onResetComplete();
				})
				.catch(() => {
					this.setState({waiting: false});
					this.props.onError();
				});
		};
	}

	render() {
		return (
			<div>
				<Form>
					<p>Please enter a new password for your account:</p>
					<div className="LoginDialog-field">
						<label htmlFor="pw">Password</label>
						<ValidatingInput
							id="pw"
							type="password"
							name="password"
							autoComplete="new-password"
							value={this.state.password}
							state={getPasswordState(this.state)}
							onKeyPress={this.handleKeyPress}
							onBlur={this.validatePassword}
							onChange={this.setPassword}
							states={{
								required: {
									message: 'Required',
									title: 'A password is mandatory for sign-up',
									icon: 'icon-warning',
									colour: '#ffc20e'
								},
								in_use: {
									message: '',
									title: ''
								},
								invalid: {
									message: '',
									title: 'This password is too short',
									icon: 'icon-error',
									colour: 'red',
									caption: 'This password is too short (minimum 8 characters)',
									captionStyle: {
										color: 'red'
									}
								},
								valid: {
									message: '',
									title: 'This password is valid',
									icon: 'icon-check',
									colour: 'green'
								}
							}}
						/>
					</div>
					<div className="LoginDialog-field">
						<label htmlFor="pwconfirm">Confirm password</label>
						<ValidatingInput
							id="pwconfirm"
							type="password"
							name="password"
							autoComplete="new-password"
							value={this.state.confirmPassword}
							state={getConfirmPasswordState(this.state)}
							onKeyPress={this.handleKeyPress}
							onChange={this.setConfirmPassword}
							states={{
								required: {
									message: 'Required',
									title: 'Please confirm your password by entering it a second time',
									icon: 'icon-warning',
									colour: '#ffc20e'
								},
								in_use: {
									message: '',
									title: ''
								},
								invalid: {
									message: '',
									title: 'The passwords do not match',
									icon: 'icon-error',
									colour: 'red',
									caption: 'The passwords do not match',
									captionStyle: {
										color: 'red'
									}
								},
								valid: {
									message: '',
									title: 'This password is valid',
									icon: 'icon-check',
									colour: 'green'
								}
							}}
						/>
					</div>
					<div className="ResetPassword-field">
						<FancyButton
							onClick={this.reset}
							disabled={
								!this.state.password ||
								this.state.password.length < 8 ||
								this.state.confirmPassword !== this.state.password
							}>
							Reset password
						</FancyButton>
					</div>
					{this.state.waiting && (
						<div className="ResetPassword-field">
							<Spinner />
						</div>
					)}
				</Form>
			</div>
		);
	}
}

const ConnectedResetPassword = connect(
	state => ({
		currentSession: state.session && state.session.current
	}),
	dispatch => ({
		showLogin: () => dispatch(uiActions.uiModal('login')),
		tryAgain: () => dispatch(uiActions.uiModal('forgot-password'))
	})
)(ResetPassword);

export default ConnectedResetPassword;



// WEBPACK FOOTER //
// ./src/user/ResetPassword.js